export function setWelcomeUsers(state, welcomes) {
  state.welcomes = welcomes;
}

export function setWelcomeUser (state, welcome){
  state.selectedWelcomeUser = welcome
}

export function welcomesError(state, payload) {
  state.error = true
  state.errorMessage = payload
  state.welcomes = []
}